import { api } from '@general/ui-kit'

// Thin wrapper over the endpoints in backend/api/routes.js. Views never build
// URLs themselves: when a route changes, only this file moves.
export const authApi = {
  login:       (email, password) => api.post('/auth/login', { email, password }),
  validateMfa: (mfaToken, code)  => api.post('/auth/mfa/validate', { mfaToken, code }),
  logout:      (refreshToken)    => api.post('/auth/logout', { refreshToken }),

  me:            ()     => api.get('/auth/me'),
  updateProfile: (data) => api.patch('/auth/me', data),

  changePassword: (currentPassword, newPassword) =>
    api.patch('/auth/password', { currentPassword, newPassword }),
  forgotPassword: (email) => api.post('/auth/password/forgot', { email }),
  resetPassword:  (token, email, newPassword) =>
    api.post('/auth/password/reset', { token, email, newPassword }),

  mfaSetup:   ()     => api.get('/auth/mfa/setup'),
  mfaVerify:  (code) => api.post('/auth/mfa/verify', { code }),
  mfaDisable: (code, userId) => api.post('/auth/mfa/disable', { code, userId }),

  // One-time rescue codes: the way back in when the phone is gone.
  recoveryCodesLeft: () => api.get('/auth/mfa/recovery-codes'),
  regenerateRecoveryCodes: (code) => api.post('/auth/mfa/recovery-codes', { code }),

  // Sessions — the open ones and the recent history, with what ended each.
  // Nothing is sent: the API knows which entry is this device from the session
  // id inside the access token we are already presenting.
  sessions: () => api.get('/auth/sessions'),
  revokeSession: (id) => api.delete(`/auth/sessions/${id}`),
  // One call rather than a list of DELETEs that can half-finish.
  revokeOtherSessions: () => api.delete('/auth/sessions'),

  requestEmailChange: (email, currentPassword) =>
    api.post('/auth/email/change', { email, currentPassword }),
}

export default authApi
